import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Title } from 'components/Title';

import CashflowStatement from './CashflowStatement';
export default function CashflowPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [AccountType, setAccountType] = useState('ALL');
const [dateFrom, setDateFrom] = useState('');
const [dateTo, setDateTo] = useState('');
    const cashbank = [
    { name: 'Cash', code: 'Cash' },
    { name: 'Bank', code: 'Bank' },
    { name: 'All', code: '' },
    ];
	return (
		<main id="CashflowPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('cashflow')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="">
                        <div className="sm:col-12 lg:col-4 md:col-4 comp-grid" >
                            <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateFrom}
                            onChange={(e) => setDateFrom(e.value)} placeholder={$t('Date From')}   />
                        </div>
                        <div className="sm:col-12 lg:col-4 md:col-4 comp-grid" >
                            <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateTo}
                            onChange={(e) => setDateTo(e.value)} placeholder={$t('Date To')}   />
                        </div>
                        <div className="sm:col-12 lg:col-4 md:col-4 comp-grid" >
                            <Dropdown 
                            value={AccountType} // Pass the code value
                            onChange={(e) => setAccountType(e.value)} // Set the code value
                            options={cashbank}
                            optionLabel="name" // Display name in dropdown
                            optionValue="code" // This ensures dropdown uses code as value
                            placeholder="Select Account Type" 
                            className="w-full md:w-14rem" 
                            />
                        </div>
                    </div>
                </div>
                <div className="">
                    <div className="">
                        <div className="sm:col-12 lg:col-12 md:col-12 comp-grid" >
                            <div className="">
                                <CashflowStatement dateFrom={dateFrom} dateTo={dateTo} AccountType={AccountType} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
